import SignUpBloggerPage from "./SignUpBloggerPage";

export default SignUpBloggerPage;